import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { AiOutlineSave } from "react-icons/ai";
import { HiOutlineDocumentText } from "react-icons/hi";
import { updateSettings } from "../../../store/settingSlice";
import {
  useUser,
  useInvoice,
  useCurrent,
  usePut,
  useLogs,
} from "../../../hooks";
import {
  MwToast,
  MwButton,
  CardAmount,
  MwSpinner,
  MwInputText,
} from "../../ui";
import CreateProduct from "../../Products/CreateProduct";
import CreateVendor from "../../Vendors/CreateVendor";
import CreateSalesman from "../../Salesmans/CreateSalesman";
import { getAllSalesman } from "../../../services/salesmanService";
import { getAllVendors } from "../../../services/vendorService";
import MwSpinnerButton from "../../ui/MwSpinnerButton";
import SideModal from "../../ui/SideModal";
import CardHeadeWithActions from "../../ui/CardHeadeWithActions";
import InvFormHeader from "./InvFormHeader";
import InvFormBody from "./InvFormBody";
import toast from "react-hot-toast";
import { amountFormat } from "../../../utils/invoceHelper";
import { formatWithCurrency } from "../../Common/formatWithCurrency";
import PromoCodeBox from "../PromoCodeBox";
import TagList from "../../ui/TagList";

const safeParseArray = (value) => {
  if (!value) {
    return [];
  }

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

const InvFormUpdate = ({ tenantId, tenantUsername, invData }) => {
  console.log("invData", invData);
  const [invTitle, setInvTitle] = useState(invData?.title || "");
  const [invTitleAr, setInvTitleAr] = useState(invData?.title_ar || "");
  const [priceListItems, setPriceListItems] = useState([]);
  const [taxesList, setTaxesList] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const { currentTenantId, currentCompanyId, currentBranchId } = useCurrent();

  const [t, i18next] = useTranslation("global");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disabledDiscount, setDisabledDiscount] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState(
    safeParseArray(invData?.attch_file),
  );
  const companySelected = useSelector((state) => state.currentCompany);
  const branchSelected = useSelector((state) => state.currentBranch);
  const { getUser } = useUser();
  const {
    initalProductItem,
    SETTING_QUOTE,
    calcSumPrice,
    calcSumNetTotal,
    toFloat,
    calcVat,
    formatter,
  } = useInvoice();
  const INV_CURRENCY = SETTING_QUOTE?.INV_CURRENCY;
  const SETTING_SHOW_INVOICE_PRODUCT_DESCRIPTION =
    SETTING_QUOTE?.SHOW_INVOICE_PRODUCT_DESCRIPTION || "false";
  const SETTING_INV_WITH_HEADER_FOOTER =
    SETTING_QUOTE?.INV_WITH_HEADER_FOOTER || "false";
  const SETTING_INV_UOM_SHOW = SETTING_QUOTE?.INV_UOM_SHOW || "false";
  const SETTING_INV_QTY_DAYS = SETTING_QUOTE?.INV_QTY_DAYS || "false";
  const SETTING_INV_CURRENCY = INV_CURRENCY || "SAR";

  const { resultLogsPost, loadingLogsPost, errorLogsPost, postDataHandler } =
    useLogs();
  const invoiceSettings = useSelector(
    (state) => state.settings,
  ).invoiceSettings;

  // products
  const [reloadProductList, setReloadProductList] = useState(false);
  const [showProductModal, setShowProductModal] = useState(false);
  // Customer
  const [customers, setCustomers] = useState([]);
  const [showCreateCustomerModal, setShowCreateCustomerModal] = useState(false);
  const [isAddedCustomer, setIsAddedcustomer] = useState(false);
  // Salesman
  const [salesmans, setSalesmans] = useState([]);
  const [showCreateSalesmanModal, setShowCreateSalesmanModal] = useState(false);
  const [isAddedSalesman, setIsAddedSalesman] = useState(false);
  // Toast
  const [showToast, setShowToast] = useState(false);
  const [msgToast, setMsgToast] = useState("");

  const {
    data: invDataPost,
    loading: invLoadingPost,
    error: invErrorPost,
    putData: invPut,
  } = usePut();
  const [formErrors, setFormErrors] = useState({});
  // Start Invoice input fields
  //console.log(invData)
  const productDetails = invData?.inv_details?.map((e, index) => {
    return {
      index,
      productId: e.product_id,
      productName: e.product_name,
      productDesc: e.product_desc || "",
      qty: e.qty,
      qtyDays: e.qty_days || 1,
      price: e.total_price,
      priceUnit: e.price,
      productDiscount: e.product_discount,
      productNetTotal: e.product_net_total,
      productVat: e.product_vat,
      productNetTotalWithVat: e.product_net_total_with_vat,
      uom: e.uom || "",
      uomTemplateId: e.uom_template_id || "",
      tax_id: e.tax_id || null, // Use existing tax_id or default to null
      tax_rate: e.tax_relation?.tax_value || invoiceSettings.INV_VAT_PERCENT, // Use tax_relation value or default setting
    };
  });
  console.log("productDetails before", productDetails);

  const [productList, setProductList] = useState(productDetails || []);
  console.log("productList usestate", productList);
  console.log("productDetails", productDetails);
  const [invNo, setInvNo] = useState(invData?.inv_no);
  const invRef = useRef(invData?.inv_ref || "");
  const invDate = useRef(invData?.inv_date);
  const invDateDue = useRef(invData?.inv_date_due);
  const invCurrency = useRef();
  const [customerSelected, setCustomerSelected] = useState({
    id: invData?._id,
    label: invData?.customer_name,
  });
  const [salesmanSelected, setSalesmanSelected] = useState([]);
  console.log("salesmanSelectedos", salesmanSelected);
  const [invNotes, setInvNotes] = useState(invData?.notes || "");
  const [invTerms, setInvTerms] = useState(invData?.terms || "");
  const [havePromoCode, setHavePromoCode] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [invTotalAmount, setInvTotalAmount] = useState(invData.total_amount);
  const [totalAmountWithDiscount, setTotalAmountWithDiscount] = useState("");
  const [discount, setDiscount] = useState(invData.discount_amount);
  const [vat, setVat] = useState(invData?.vat_amount);
  const [netTotal, setNetTotal] = useState(invData?.net_amount);
  const [tagList, setTagList] = useState(safeParseArray(invData?.inv_tags));
  ////////////////////////////////////////////////

  const initalCustomerName = invData?.customer_name || "";
  const initalSalesmanName = invData?.salesman_name || "";
  const initalSalesmanId = invData?.salesman_id || "";
  // Promo Code
  const promoCodeHandler = () => {};
  // Product Functions
  const showModalProductHandle = () => {
    setShowProductModal(true);
  };
  const onProductCreated = () => {
    setReloadProductList(true);
  };

  // Customer Functions
  const onCustomerCreated = () => {
    setIsAddedcustomer(true);

    // setMsgToast('Customer Has been added...')
    // setShowToast(true);
  };
  const onClickNewCustomer = () => {
    setShowCreateCustomerModal(true);
    setIsAddedcustomer(false);
  };

  // Salesman Functions
  const onSalesmanCreated = () => {
    setIsAddedSalesman(true);
    // setMsgToast('Salesman Has been added...')
    // setShowToast(true);
  };
  const onClickNewSalesman = () => {
    setShowCreateSalesmanModal(true);
    setIsAddedSalesman(false);
  };
  const calcSum = () => {
    return calcSumPrice(productList);
  };

  // const invSumHandler = () => {
  //     const sum = calcSum();
  //     const _totalAmountWithDiscount =  sum - discount;
  //     setInvTotalAmount(sum);
  //     setTotalAmountWithDiscount(_totalAmountWithDiscount);
  //     vatHandler(_totalAmountWithDiscount);
  // }
  const invSumHandler = () => {
    console.log("invSumHandler");
    const sum = calcSum();
    const netTotal = calcSumNetTotal(productList);
    const _discountItems = sum - netTotal;

    _discountItems > 0 ? setDisabledDiscount(true) : setDisabledDiscount(false);
    if (disabledDiscount && _discountItems >= 0) {
      setDiscount(amountFormat(_discountItems));
    }
    const _totalAmountWithDiscount = sum - discount;
    setInvTotalAmount(sum);
    setTotalAmountWithDiscount(_totalAmountWithDiscount);
    vatHandler(_totalAmountWithDiscount);
    console.log("total => ", invTotalAmount, totalAmountWithDiscount);
  };
  // const vatHandler = (total=totalAmountWithDiscount) => {
  //     const calcvat = calcVat(total)
  //     setVat(calcvat)

  //     const nt = toFloat(calcvat,false) + toFloat(total,false)
  //     setNetTotal(nt)

  // }

  // const discountHandler = () => {
  //     invSumHandler();
  // }
  const vatHandler = (total = totalAmountWithDiscount) => {
    // Calculate the sum of VAT from all product items
    const totalVatFromProducts = productList.reduce((sum, product) => {
      // Skip deleted products
      if (product && product.productName !== "Deleted") {
        return sum + parseFloat(product.productVat || 0);
      }
      return sum;
    }, 0);

    // Set the VAT amount based on product items
    setVat(totalVatFromProducts);

    // Calculate net total: (total - discount) + VAT
    const invTotal = toFloat(total, false);
    const invDiscount = toFloat(discount, false);

    const net = invTotal - invDiscount + totalVatFromProducts;
    setNetTotal(toFloat(net));
  };

  const discountHandler = () => {
    invSumHandler();
  };
  useEffect(() => {
    if (!Array.isArray(productList)) return;
    const sum = calcSum();
    const totalVat = productList.reduce((acc, product) => {
      if (product?.productId !== "section" && product?.productVat) {
        return acc + parseFloat(product.productVat || 0);
      }
      return acc;
    }, 0);
    const discountAmount = toFloat(discount, false);
    const totalAfterDiscount = toFloat(sum - discountAmount, false);
    const net = toFloat(totalAfterDiscount + toFloat(totalVat, false));

    setInvTotalAmount(sum);
    setTotalAmountWithDiscount(totalAfterDiscount);
    setVat(toFloat(totalVat, false));
    setNetTotal(net);
  }, [productList, discount]);

  // add new useEffect vat handler
  // useEffect(() => {
  //     netTotalHandler(); // Recalculate net total
  //     vatHandler(); // Recalculate VAT and net total
  // }, [invTotalAmount, vat, discount]);
  const netTotalHandler = () => {
    const invTotal = toFloat(invTotalAmount, false);
    const invDiscount = toFloat(discount, false);
    const invVat = toFloat(vat, false);
    const net = toFloat(invTotal - invDiscount + invVat);
    setNetTotal(net);
  };

  const discountOnchange = (value) => {
    const sum = calcSum();
    let discountValue;
    if (value.includes("%")) {
      invSumHandler();
      discountValue = toFloat(
        (toFloat(sum, false) * toFloat(value.replace("%", ""), false)) / 100,
      );
      console.log(discountValue);
    } else {
      discountValue = value;
    }
    setDiscount(() => discountValue);
  };
  const validateForm = () => {
    setFormErrors({});
    let errors = {};
    if (!invDate?.current.value) {
      errors.invDate = "Date is required";
    }
    if (!invDateDue?.current.value) {
      errors.invDateDue = "Date Due is required";
    }
    if (!!productList[0].productId === false) {
      errors.productList = "you must select a product";
    }

    if (Object.keys(errors).length > 0) {
      setFormErrors({ ...errors });
      return false;
    }
    return true;
  };

  const onsubmitHandler = (e) => {
    if (e.key === "Enter") return;
    e.preventDefault();
    // validate form
    if (!validateForm()) return;
    console.log("productList", productList);

    let productListHandler = [];
    productList?.map((product) => {
      if (product && product.productName !== "Deleted") {
        productListHandler.push({
          id: product.id,
          product_id: product.productId,
          productdesc: product.product_desc || "",
          product_name: product.productName,
          unit_id: 1,
          qty: product.qty,
          price: parseFloat(product.price) / parseInt(product.qty),
          total_price: product.price,
          product_discount: product.productDiscount || 0,
          product_net_total: product.productNetTotal,
          product_vat: product.productVat,
          product_net_total_with_vat: product.productNetTotalWithVat,
          tax_id: product.tax_id ?? null,
        });
      }
    });

    const normalizeEditorValue = (value) => {
      if (value == null) return JSON.stringify("");
      if (typeof value === "string") {
        const trimmed = value.trim();
        if (!trimmed) return JSON.stringify("");
        if (trimmed.startsWith("{") || trimmed.startsWith("[")) return trimmed;
        try {
          const parsed = JSON.parse(trimmed);
          if (parsed && typeof parsed === "object")
            return JSON.stringify(parsed);
          if (typeof parsed === "string") {
            const parsedTrimmed = parsed.trim();
            if (parsedTrimmed.startsWith("{") || parsedTrimmed.startsWith("["))
              return parsedTrimmed;
          }
        } catch {}
        return JSON.stringify(trimmed);
      }
      return JSON.stringify(value);
    };
    const _data = {
      inv_no: invNo,
      inv_ref: invRef?.current.value,
      inv_date: invDate?.current.value,
      inv_date_due: invDateDue?.current.value,
      customer_id: customerSelected?._id,
      customer_name: customerSelected?.label,
      // salesman_id:salesmanSelected?._id,
      // salesman_name:salesmanSelected?.label,
      total_amount: invTotalAmount,
      discount_amount: discount,
      // promo_code_id:
      // promo_code:
      vat_amount: vat,
      net_amount: netTotal,
      notes: normalizeEditorValue(invNotes),
      terms: normalizeEditorValue(invTerms),
      is_paid: false,
      type_id: 1,
      status_id: 1,
      tenant_id: tenantId,
      company_id: companySelected.value,
      branch_id: branchSelected.value,
      created_by: getUser?._id || 0,
      inv_tags: JSON.stringify(tagList),
      inv_details: productListHandler,
      attch_file: JSON.stringify(attachedFiles),
      currency_id: selectedCurrency?.value || null,
    };
    console.log("_datainvPut", _data);
    console.log("_datainvPuts", invPut);

    invPut(
      `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/invoices/update/${invData.id}`,
      _data,
    );
  };

  const getcustomerHandler = async () => {
    const res = await getAllVendors(
      tenantId,
      companySelected.value,
      branchSelected.value,
    );
    setCustomers(res);
  };

  const getSalesmanHandler = async () => {
    const res = await getAllSalesman(
      tenantId,
      companySelected.value,
      branchSelected.value,
    );
    setSalesmans(res);
  };

  const setLogsHandler = () => {
    const _data = {
      moduleName: "SALES",
      resourceName: "INVOICES",
      eventName: "UPDATE",
      logContentEn: `Update invoice No: ${invDataPost.inv_no}`,
      logContentAr: `تعديل فاتورة برقم : ${invDataPost.inv_no}`,
    };
    postDataHandler(_data);
  };

  const extractCurrencySymbol = () => {
    let formatterToUse;

    if (selectedCurrency) {
      const currencyCode = selectedCurrency.currency_code?.trim() || "SAR";

      formatterToUse = new Intl.NumberFormat(i18next.language, {
        style: "currency",
        currency: currencyCode.toUpperCase(),
      });
    } else {
      formatterToUse = formatter;
    }

    const formattedZero = formatterToUse.format(0);
    let currencySymbol = formattedZero.replace(/[0-9.,\s]/g, "");

    if (
      currencySymbol.length > 1 &&
      !/[$€£¥₹₽₺₴₿¢₱₩₫₲₸₼₾﷼]/g.test(currencySymbol)
    ) {
      currencySymbol = currencySymbol.split("").join(".");
    }

    return currencySymbol;
  };

  const currencySymbol = extractCurrencySymbol();

  useEffect(() => {
    if (invDataPost) {
      setLogsHandler();
    }
  }, [invDataPost]);

  useEffect(() => {
    const updatedInvoice = invDataPost?.data ?? invDataPost;
    if (!updatedInvoice) return;
    if (updatedInvoice?.status === 0) {
      toast.error("حدث خطأ أثناء تحديث الفاتورة");
      return;
    }
    const invoiceId = updatedInvoice?.id || invData?.id;
    if (!invoiceId) return;
    toast.success("تم تحديث الفاتورة بنجاح");
    const targetCompanyId =
      updatedInvoice?.company_id || invData?.company_id || currentCompanyId;
    const targetBranchId =
      updatedInvoice?.branch_id || invData?.branch_id || currentBranchId;
    const timer = setTimeout(() => {
      navigate(
        `/${tenantUsername}/invoices/show/${invoiceId}/${targetCompanyId}/${targetBranchId}`,
      );
    }, 1800);
    return () => clearTimeout(timer);
  }, [
    invDataPost,
    invData,
    navigate,
    tenantUsername,
    currentCompanyId,
    currentBranchId,
  ]);

  useEffect(() => {
    setProductList([...productDetails]);
    getcustomerHandler();
    getSalesmanHandler();
    console.log("invData", invData, productList);
  }, []);

  useEffect(() => {
    if (isAddedCustomer) {
      getcustomerHandler();
    }
  }, [isAddedCustomer]);

  useEffect(() => {
    if (isAddedSalesman) {
      getSalesmanHandler();
    }
  }, [isAddedSalesman]);

  useEffect(() => {
    if (invErrorPost) {
      toast.error("حدث خطأ أثناء حفظ الفاتورة", {
        toastId: "error-save",
        position: "top-center",
        autoClose: 3000,
      });
    }
  }, [invErrorPost]);

  useEffect(() => {
    dispatch(
      updateSettings({
        typeSetting: "invoice",
        value: {
          INV_ITEMS_ROW_NUMBER: productList.length + 1,
        },
      }),
    );
  }, [productList, dispatch]);

  useEffect(() => {
    setIsLoading(true);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (invData) {
      setSalesmanSelected({
        label: invData?.salesman_name,
        _id: invData?.salesman_id,
      });
      setCustomerSelected({
        label: invData?.customer_name,
        _id: invData?.customer_id,
      });
    }
  }, []);

  useEffect(() => {
    if (currencies.length > 0 && invData.currency_id) {
      const matchingCurrency = currencies.find(
        (curr) => curr.id == invData.currency_id,
      );

      if (matchingCurrency) {
        setSelectedCurrency({
          value: invData.currency_id,
          label:
            matchingCurrency.name_ar ||
            matchingCurrency.name_en ||
            "الريال السعودي",
          currency_code: matchingCurrency.currency_code?.trim() || "SAR",
        });
      }
    }
  }, [currencies, invData.currency_id]);

  useEffect(() => {
    const fetchCurrencies = async () => {
      const baseUrl = `${process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL}/currencies/${currentTenantId}/${currentCompanyId}`;
      try {
        const response = await fetch(baseUrl);
        if (!response.ok) {
          throw new Error("Failed to fetch currencies");
        }
        const data = await response.json();
        setCurrencies(data?.data || []);
      } catch (error) {
        console.error("Error fetching currencies:", error);
      }
    };

    if (currentTenantId && currentCompanyId) {
      fetchCurrencies();
    }
  }, [currentTenantId, currentCompanyId]);

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center items-center h-screen">
          <MwSpinner size="large" />
        </div>
      ) : (
        <>
          {showToast && (
            <MwToast
              msg={msgToast}
              isShow={showToast}
              setIsShow={setShowToast}
            />
          )}

          <SideModal
            title="Create New Product"
            onShow={showProductModal}
            setOnShow={setShowProductModal}
          >
            <CreateProduct
              onProductCreated={onProductCreated}
              setReloadProductList={setReloadProductList}
            />
          </SideModal>

          <SideModal
            title="Create New Customer"
            onShow={showCreateCustomerModal}
            setOnShow={setShowCreateCustomerModal}
          >
            <CreateVendor onVendorCreated={onCustomerCreated} />
          </SideModal>

          <SideModal
            title="Create New Salesman"
            onShow={showCreateSalesmanModal}
            setOnShow={setShowCreateSalesmanModal}
          >
            <CreateSalesman onSalesmanCreated={onSalesmanCreated} />
          </SideModal>
          <form onSubmit={onsubmitHandler} className="flex flex-col gap-6 pb-3">
            <CardHeadeWithActions
              title={`${t("quotes.Edit Purchase Order No.")} ${invData?.inv_no || ""}`}
              icon={<HiOutlineDocumentText size={24} />}
            >
              {invLoadingPost ? (
                <MwSpinnerButton />
              ) : (
                <>
                  <MwButton
                    actionType="button"
                    inGroup={true}
                    type="saveBtn"
                    onClick={() => navigate(`/${tenantUsername}/invoices`)}
                    classNameCustom="hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                  >
                    <HiOutlineDocumentText size={18} /> {t("menu.Invoices")}
                  </MwButton>
                  <MwButton
                    actionType="submit"
                    inGroup={true}
                    type="saveBtn"
                    disabled={isSubmitting}
                    classNameCustom="hover:shadow-lg transition-all duration-200 flex items-center gap-2"
                  >
                    <AiOutlineSave size={18} /> {t("invoice.saveInvoice")}
                  </MwButton>
                </>
              )}
            </CardHeadeWithActions>
            <div className="px-3 mt-[-10px]">
              <div className="flex flex-col h-full bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden divide-y divide-gray-100">
                <div className="p-6 mt-[-10px]">
                  <div className="mb-4">
                    <h3 className="text-xs font-semibold text-[#251658] uppercase tracking-wider">
                      البيانات الأساسية
                    </h3>
                  </div>
                  <InvFormHeader
                    invNo={invNo}
                    setInvNo={setInvNo}
                    invRef={invRef}
                    invTitle={invTitle}
                    setInvTitle={setInvTitle}
                    invTitleAr={invTitleAr}
                    setInvTitleAr={setInvTitleAr}
                    invDate={invDate}
                    invDateDue={invDateDue}
                    invCurrency={invCurrency}
                    customers={customers}
                    onClickNewCustomer={onClickNewCustomer}
                    salesmans={salesmans}
                    onClickNewSalesman={onClickNewSalesman}
                    customerSelected={customerSelected}
                    setCustomerSelected={setCustomerSelected}
                    salesmanSelected={salesmanSelected}
                    setSalesmanSelected={setSalesmanSelected}
                    formErrors={formErrors}
                    initalCustomerName={initalCustomerName}
                    initalSalesmanName={initalSalesmanName}
                    initalSalesmanId={initalSalesmanId}
                    priceListItems={priceListItems}
                    setPriceListItems={setPriceListItems}
                    //  SETTING_PRICE_INCLUDE_VAT = {SETTING_QUOTE.PRICE_INCLUDE_VAT}
                    SETTING_INVOICE={SETTING_INV_CURRENCY}
                    productList={productList}
                    setProductList={setProductList}
                    taxesList={taxesList}
                    setTaxesList={setTaxesList}
                    setCurrencies={setCurrencies}
                    currencies={currencies}
                    currentCompanyId={currentCompanyId}
                    currentTenantId={currentTenantId}
                    setSelectedCurrency={setSelectedCurrency}
                    selectedCurrency={selectedCurrency}
                    currencySymbol={currencySymbol}
                  />
                </div>

                <div className="p-6 bg-gray-50 hover:bg-gray-100 transition-colors duration-300">
                  <div className="mb-4">
                    <h3 className="text-xs font-semibold text-[#251658] uppercase tracking-wider">
                      الإضافات
                    </h3>
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="p-4 pb-8 bg-white rounded-xl border border-gray-200">
                      <TagList tagList={tagList} setTagList={setTagList} />
                    </div>
                    <div className="p-4 bg-white rounded-xl border border-gray-200 flex items-center">
                      <PromoCodeBox
                        havePromoCode={havePromoCode}
                        setHavePromoCode={setHavePromoCode}
                        promoCode={promoCode}
                        setPromoCode={setPromoCode}
                        promoCodeHandler={promoCodeHandler}
                      />
                    </div>
                  </div>
                </div>

                <div className="p-6 flex-1 overflow-auto bg-white">
                  <div className="mb-4">
                    <h3 className="text-xs font-semibold text-[#251658] uppercase tracking-wider">
                      التفاصيل
                    </h3>
                  </div>
                  <InvFormBody
                    SETTING_SHOW_INVOICE_PRODUCT_DESCRIPTION={
                      SETTING_SHOW_INVOICE_PRODUCT_DESCRIPTION
                    }
                    SETTING_INV_QTY_DAYS={SETTING_INV_QTY_DAYS}
                    SETTING_INV_UOM_SHOW={SETTING_INV_UOM_SHOW}
                    initalProductItem={productDetails}
                    reloadProductList={reloadProductList}
                    showModalProductHandle={showModalProductHandle}
                    productList={productList}
                    setProductList={setProductList}
                    formErrors={formErrors}
                    invNotes={invNotes}
                    invTerms={invTerms}
                    setInvNotes={setInvNotes}
                    setInvTerms={setInvTerms}
                    isEdit={true}
                    priceListItems={priceListItems}
                    setVat={setVat}
                    invoiceSettings={invoiceSettings}
                    taxesList={taxesList}
                    setTaxesList={setTaxesList}
                    attachedFiles={attachedFiles}
                    setAttachedFiles={setAttachedFiles}
                  />
                </div>

                <div className="p-6 bg-gradient-to-b from-gray-50 to-white border-t-2 border-gray-200 hover:from-gray-100 transition-colors duration-300">
                  <div className="mb-4">
                    <h3 className="text-xs font-semibold text-[#251658] uppercase tracking-wider">
                      الملخص المالي
                    </h3>
                  </div>
                  <div className="flex md:flex-row flex-col gap-4 items-start justify-between text-sm">
                    <div className="flex-1  flex items-start justify-between gap-3">
                      <CardAmount
                        label="الإجمالي قبل الخصم"
                        amountValue={formatWithCurrency(
                          invTotalAmount,
                          selectedCurrency,
                          formatter,
                          amountFormat,
                        )}

                        //footerValue={formatter.format(SETTING_INV_CURRENCY)}
                      />
                      <div id="discount-card" className=" flex-1 text-center ">
                        <div className=" text-[#251658] mb-1 text-xs">
                          {" "}
                          الخصم علي الإجمالي{" "}
                        </div>
                        <MwInputText
                          value={discount}
                          // disabled={disabledDiscount}
                          disabled={true}
                          // placeholder={t('invoice.discount')}
                          classNameInput="font-bold py-2"
                          size="sm"
                          onChange={(e) => discountOnchange(e.target.value)}
                        />
                        {/* <div className='text-slate-400 text-xs'>{ discount && SETTING_INV_CURRENCY.toUpperCase() }</div> */}
                      </div>
                      <CardAmount
                        label="الإجمالي بعد الخصم"
                        amountValue={formatWithCurrency(
                          totalAmountWithDiscount,
                          selectedCurrency,
                          formatter,
                          amountFormat,
                        )}
                        // footerValue={SETTING_INV_CURRENCY.toUpperCase()}
                      />
                    </div>
                    <div className="flex-1 flex items-center justify-between">
                      <CardAmount
                        label={t("invoice.vatAmount")}
                        amountValue={formatWithCurrency(
                          vat,
                          selectedCurrency,
                          formatter,
                          amountFormat,
                        )}
                        // footerValue={SETTING_INV_CURRENCY.toUpperCase()}
                      />
                      <CardAmount
                        label={t("invoice.netTotal")}
                        amountValue={formatWithCurrency(
                          netTotal,
                          selectedCurrency,
                          formatter,
                          amountFormat,
                        )}
                        // footerValue={SETTING_INV_CURRENCY.toUpperCase()}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </>
      )}
    </>
  );
};

export default InvFormUpdate;
